export const LAN_EN_NAME = 'English';
export const LAN_EN_KEY = 'en';
export const LAN_ZH_KEY = 'zh_CN';
export const ACCESS_TOKEN_SESSION_KEY = 'access_token_key';
export const STATUS_CODE = {
  SUCCESS: 200,
  UNAUTHENTICATED: 401
};
export const LANDING_VERSION = ['2.1.0', '2.2.0', '2.3.0', '2.4.0', '2.4.4', '3.0.0', '3.1.0'];
export const LATEST_VERSION = ['3.1.0', '3.0.0', '2.4.4'];
